module.exports = "https://cdn.thelire.com/ins/resource/paymentVipAddLikes.fd84913d401db6cd4b345fc784877786.png";